  export const toTop = () => {
    window.scrollTo(0, 0);
  };

  export default {toTop }
